(function() {
    const escapeBtn = document.getElementById('quick-escape');
    const safeSite = escapeBtn ? escapeBtn.dataset.escapeUrl : 'https://www.google.com';
    // Check if user has already escaped - if so, redirect immediately
    if (sessionStorage.getItem('hasEscaped') === 'true') {
        window.location.replace(safeSite);
        return;
    }

    // Function to set up the back button trap (only after escape is triggered)
    function setupBackButtonTrap() {
        history.pushState(null, document.title, location.href);
        
        window.addEventListener('popstate', function() {
            // Redirect to the safe site
            sessionStorage.setItem('hasEscaped', 'true');
            window.location.href = safeSite;
        });
    }

    // Function to perform the "Clean" redirect
    function triggerEscape() {
        // Set up the back button trap first
        setupBackButtonTrap();
        // Set flag so any back navigation will also redirect
        sessionStorage.setItem('hasEscaped', 'true');
        // location.replace ensures this page isn't in the "Back" button history
        window.location.replace(safeSite);
    }

    // 1. Handle the Button Click
    if (escapeBtn) {
        escapeBtn.addEventListener('click', function(e) {
            e.preventDefault();
            triggerEscape();
        });
    }

    // 2. Handle the "Esc" Keyboard Shortcut
    document.addEventListener('keydown', function(e) {
        if (e.key === "Escape") {
            triggerEscape();
        }
    });


})();